import DOMPurify from "dompurify";

/**
 * Sanitize an untrusted/raw HTML string for safe rendering.
 *
 * Use this ONLY for content that is genuinely HTML (e.g. server-provided news
 * bullets) and therefore cannot go through a markdown component. DOMPurify
 * strips dangerous protocols (javascript:, data:, vbscript:), `<script>` tags,
 * and inline event handlers, so the result is safe for `dangerouslySetInnerHTML`.
 *
 * For AI-generated / markdown content, do NOT use this — render with
 * <ReactMarkdown> instead, which never emits raw executable HTML.
 *
 * @param {string} html Untrusted HTML.
 * @returns {string} Sanitized HTML string.
 */
export function sanitizeHtml(html) {
  if (html == null) return "";
  return DOMPurify.sanitize(String(html));
}
